'use strict';

var React = require('react');

var SvgVariantMajor = function SvgVariantMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.01 6.01a2.75 2.75 0 0 1 2.74-2.51h5a2.75 2.75 0 0 1 2.75 2.75v5a2.75 2.75 0 0 1-2.51 2.74 2.75 2.75 0 0 1-2.74 2.51h-5a2.739 2.739 0 0 1-1.771-.646 1.001 1.001 0 0 1-.333-.333 2.739 2.739 0 0 1-.646-1.771v-5a2.75 2.75 0 0 1 2.51-2.74Zm1.515-.01h3.725c.675 0 1.293.243 1.771.646a1.003 1.003 0 0 1 .333.333c.403.478.646 1.096.646 1.771v3.725c.57-.116 1-.62 1-1.225v-5c0-.69-.56-1.25-1.25-1.25h-5c-.605 0-1.11.43-1.225 1Zm-1.275 1.5h4.836l-6.086 6.086v-4.836c0-.69.56-1.25 1.25-1.25Zm5 7.5h-4.836l6.086-6.086v4.836c0 .69-.56 1.25-1.25 1.25Z"
  }));
};
SvgVariantMajor.displayName = "VariantMajor";

exports.SvgVariantMajor = SvgVariantMajor;
